import { filter, map } from "lodash";
import { AICC_PROMPT_GROUPS_IN_ORDER, AiccPromptGroup } from "constants/aiccPrompt";
import { AiccPromptSharedModel } from "types/model/aiccPrompt";

export interface SharedPromptGroup {
  group: AiccPromptGroup;
  prompts: AiccPromptSharedModel[];
}

export const groupSharedPrompts = (sharesModelWith: AiccPromptSharedModel[]): SharedPromptGroup[] =>
  filter(
    map(AICC_PROMPT_GROUPS_IN_ORDER, (group) => ({ group, prompts: filter(sharesModelWith, { group }) })),
    ({ prompts }) => !!prompts.length
  );
